import OperatorSubscriptions from "../operator/OperatorSubscriptions";

// Same list as the operators: companies and their subscriptions
export default OperatorSubscriptions;
